
















































// eslint-disable-next-line no-unused-vars
import Vue, { PropType } from 'vue';
// import { editDelegates, getAllDelegates } from '@/api/delegates';
import CardStack from '@/components/CardStack/index.vue';
// eslint-disable-next-line no-unused-vars
import { delegatesType } from '@/types/api';

export default Vue.extend({
  components: {
    CardStack,
  },
  data() {
    return {
      button: 'Present &amp;&nbsp;Voting' as string,
      voteCount: 0 as number,
      currentCountry: 0 as number,
    };
  },
  props: {
    delegatesData: Array as PropType<delegatesType.getAllDelegates[]>,
  },
  methods: {
    // async presence(j: string): Promise<void> {
    async presence(): Promise<void> {
      // try {
      //   const data = {
      //     country: this.delegatesData[this.currentCountry].country,
      //     status: j,
      //   };
      //   await editDelegates(
      //     this.$route.params.id,
      //     this.delegatesData[this.currentCountry]._id,
      //     data,
      //   );
      //   this.$emit('update');
      //   this.getVoteCount();
      // } catch (err) {
      //   console.error(err);
      // }
      this.move(this.currentCountry + 1);
    },
    move(index: number): void {
      const j = Math.min(Math.max(parseInt(index.toString(), 10), 0),
        this.delegatesData.length - 1);
      this.currentCountry = j;
    },
    async getVoteCount(): Promise<void> {
      // const vote = await getAllDelegates(this.$route.params.id);
      this.voteCount = (this.delegatesData.filter((obj: delegatesType.getAllDelegates) => obj.status !== 'N/A')).length;
    },
    decoder(str: string): string { // Vue workaround for &nbsp;
      const textArea = document.createElement('textarea');
      textArea.innerHTML = str;
      return textArea.value;
    },
  },
  created() {
    this.getVoteCount();
  },
});
